<template>
    <div>
        <div class="flex-between">
            <el-button
                class="primary"
                type="primary"
                @click="add()"
            >新增</el-button>
        </div>
        <div>
            <el-table
                :header-cell-style="{
					background: 'rgba(229,244,255,1)',
					color: '#0077CC',
					fontWeight: 'bold'
				}"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="filePath" label="封面" header-align="center" align="center">
                    <template slot-scope="scope">
                        <img :src="httpUrl+'/disk/'+scope.row.filePath" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="filePathList" label="图标" header-align="center" align="center" width="250">
                    <template slot-scope="scope">
                        <div class="flex-between">
                        <p v-for="(item,index) in scope.row.filePathList" :key="index">
                            <img :src="httpUrl+'/disk/'+item" alt="" style="width:60px; margin-right:10px;">
                        </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="busName" label="业务名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="busSynopsis" label="业务简介" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="" @click="listFun(scope.row.id)">说明</el-button>
                        <el-button type="text" class="" @click="sortFun(scope.row.id)">图标排序</el-button>
                        <el-button type="text" class="" @click="edit(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="flex-end">
            当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.currentPage"
                :page-size="queryData.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="60%"
            :close-on-click-modal="false"
            :before-close="cancel"
            >
            <div>
                <el-form
                    :model="form"
                    label-width="100px"
                >
                    <el-form-item label="业务名称">
                        <el-input v-model="form.busName"></el-input>
                    </el-form-item>
                    <el-form-item label="封面">
                        <el-upload
                            class="avatar-uploader"
                            :action="`${httpUrl}/file/UploadPng`"
                            :show-file-list="false"
                            :on-success="successFun"
                        >
                            <img
                                v-if="form.filePath"
                                :src="httpUrl+'/disk/'+form.filePath"
                                class="avatar"
                                style="max-width:300px"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="业务封面">
                        <el-upload
                            class="avatar-uploader"
                            :action="`${httpUrl}/file/UploadPng`"
                            :show-file-list="false"
                            :on-success="successFun3"
                        >
                            <img
                                v-if="form.busPath"
                                :src="httpUrl+'/disk/'+form.busPath"
                                class="avatar"
                                style="max-width:300px"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                     <el-form-item label="排序">
                        <el-input v-model="form.indexes"></el-input>
                    </el-form-item>
                    <el-form-item label="图标">
                        <el-upload
                            ref="file"
                            list-type="picture-card"
                            :action="`${httpUrl}/file/UploadPng`"
                            :on-success="successFun1"
                            :on-remove="handleRemove1"
                            :file-list="imgList"
                            multiple
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="业务简介">
                        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10}" v-model="form.busSynopsis"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="el-button" @click="cancel">取 消</el-button>
                <el-button class="el-button1" @click="save()">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="title"
            :visible.sync="dialogsort"
            width="60%"
            :close-on-click-modal="false"
            :before-close="cancel"
            >
            <div class="sort-blk">
                <div v-for="(item,index) in formSort" :key="'2'+index">
                    <div class="img">
                        <img :src="httpUrl+'/disk/'+item.filePath" alt="">
                    </div>
                    <el-input type="text" v-model="item.sortName" placeholder="排序" @change="saveSort(item.id,item.sortName)"></el-input>
                </div>
            </div>
        </el-dialog>
        <!-- 说明列表 -->
        <el-dialog
            title="说明"
            :visible.sync="dialogList"
            width="60%"
            :close-on-click-modal="false"
            :before-close="cancel2"
            >
            <div class="table-blk">
                <p class="add-btn" @click="addExp()">新增</p>
                 <el-table
                    :header-cell-style="{
                        background: 'rgba(229,244,255,1)',
                        color: '#0077CC',
                        fontWeight: 'bold'
                    }"
                    align="center"
                    header-align="center"
                    :data="tableDataList"
                    style="width: 100%"
                >
                    <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="explainText" label="说明" header-align="center" align="center"></el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" class="" @click="editExp(scope.row.id)">编辑</el-button>
                            <el-button type="text" @click="delExp(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                 </el-table>
            </div>
            <div class="flex-end">
            当前 第 {{queryData2.currentPage}} 页，共 {{queryData2.pages}} 页 {{queryData2.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="queryData2.currentPage"
                :page-size="queryData2.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData2.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>
        </el-dialog>
        <el-dialog
            :title="titleExp"
            :visible.sync="dialogExp"
            width="60%"
            :close-on-click-modal="false"
            :before-close="cancel2"
            >
            <div>
                <el-form
                    :model="formExp"
                    label-width="100px"
                >
                    <el-form-item label="标题">
                        <el-input v-model="formExp.title"></el-input>
                    </el-form-item>
                    <el-form-item label="说明">
                        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10}" v-model="formExp.explainText"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="formExp.indexOrder"></el-input>
                    </el-form-item>
                    <el-form-item label="是否显示">
                        <el-radio v-model="formExp.state" :label="0">显示</el-radio>
                        <el-radio v-model="formExp.state" :label="1">不显示</el-radio>
                    </el-form-item>
                    <el-form-item label="图标地址">
                        <el-upload
                            class="avatar-uploader"
                            :action="`${httpUrl}/file/UploadPng`"
                            :show-file-list="false"
                            :on-success="successFun5"
                        >
                            <img
                                v-if="formExp.path"
                                :src="httpUrl+'/disk/'+formExp.path"
                                class="avatar"
                                style="max-width:300px"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="el-button" @click="cancel2">取 消</el-button>
                <el-button class="el-button1" @click="saveExp()">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    listByPage,//列表查询
    insert,
    querySingle,
    update,
    del,
    listBySort,
    updateFileSort,
    listByPageExp,
    deleteMutil,
    insertExp,
    updateExp,
    querySingleExp
} from "../../../api/business.js";
export default {
    name: "breadcrumbList",
    data() {
        return {
            httpUrl:process.env.VUE_APP_URL,
            tableData: [],
            formSort:[],
            dialogVisible: false,
            dialogsort:false,
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
            },
            queryData2: {
                currentPage: 1, //当前页
                pageSize: 10,
            },
            isAdd:0,
            form:{
                filePath:"",
            },
            title:"",
            // fileIds:[],
            imgList:[],
            // 说明
            dialogList:false,
            dialogExp:false,
            tableDataList:[],
            formExp:{
                path:''
            },
            isAddExp:0,
            busId:'',
            titleExp:'',
        };
    },
    methods: {

        // 说明
        listFun(val){
            this.busId=val;
            this.listByPageExpFun();
            this.dialogList=true;
        },
        listByPageExpFun(){
            listByPageExp({
                currentPage: this.queryData2.currentPage,
                pageSize: this.queryData2.pageSize,
                busId:this.busId
            }).then(res=>{
                if(res.code==200){
                    this.tableDataList=res.data.list;
                    this.queryData2.total = res.data.total;
                    this.queryData2.pages = res.data.pages;
                }
            })
        },
        addExp(){
            this.dialogExp=true;
            this.isAddExp=1;
        },
        delExp(val){
            deleteMutil({ids:val}).then(res=>{
                if(res.code==200){
                        this.$message.success("删除成功！");
                        this.listByPageExpFun();
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
         saveExp(){
            if(this.isAddExp==1){
                this.formExp.busId=this.busId;
                insertExp(this.formExp).then(res=>{
                    if(res.code==200){
                        this.$message.success("新增成功！");
                        this.dialogExp=false;
                        this.formExp={};
                        this.isAddExp=0;
                        this.listByPageExpFun();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
            else{
                updateExp(this.formExp).then(res=>{
                    if(res.code==200){
                        this.$message.success("修改成功！");
                        this.dialogExp=false;
                        this.formExp={};
                        this.isAddExp=0;
                        this.listByPageExpFun();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
        },
        editExp(val){
            this.titleExp="编辑";
            querySingleExp({id:val}).then(res=>{
                if(res.code==200){
                        this.dialogExp=true;
                        this.formExp=res.data;
                        this.formExp.path=res.data.path;
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
        saveSort(id,sort){
            updateFileSort({id:id,sortName:sort}).then(res=>{
                if(res.code==200){
                    this.$message.success('操作成功！')
                }
            })
        },
        sortFun(val){
            listBySort({id:val}).then(res=>{
                if(res.code==200){
                    this.dialogsort=true;
                    this.formSort=res.data;
                    console.log(res.data)
                }
            })
        },
        handleSizeChange(val) {
              this.queryData.pageSize = val;
              this.listByPageFun();
        },
        handleCurrentChange(val) {
              this.queryData.currentPage = val;
            this.listByPageFun()
        },
        handleSizeChange2(val) {
              this.queryData2.pageSize = val;
              this.listByPageExpFun();
        },
        handleCurrentChange2(val) {
              this.queryData2.currentPage = val;
            this.listByPageExpFun()
        },
        //列表
        listByPageFun() {
            listByPage({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
            })
                .then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total;
                        this.queryData.pages = res.data.pages;
                        let that=this;
                        for(let i=0; i<that.tableData.length;i++){
                            that.tableData[i].filePathList=[];
                            that.tableData[i].filePathList=that.tableData[i].filesPaths.split(',');
                        }
                        console.log("0000",that.tableData)
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
        },
        add(){
            this.title="新增";
            this.dialogVisible=true;
            this.isAdd=1;
        },
        edit(val){
            this.title="编辑";
            querySingle({id:val}).then(res=>{
                if(res.code==200){
                        this.dialogVisible=true;
                        this.form=res.data.detail;
                        this.form.filePath=res.data.detail.filePath;
                        this.form.busPath=res.data.detail.busPath;
                        for(let i=0; i<res.data.files.length;i++){
                            // this.fileIds.push({id:res.data.files[i].id,filePath:res.data.files[i].filePath})
                            this.imgList.push({id:res.data.files[i].id,url:this.httpUrl+'/disk/'+res.data.files[i].filePath})
                        }
                        // console.log("图片回调",this.fileIds)
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
        successFun(file){
            this.form.fileId=file.data.id;
            this.form.filePath=file.data.filePath;
        },
        successFun3(file){
            // this.form.fileId=file.data.id;
            this.form.busPath=file.data.filePath;
        },
        successFun1(file,fileList){
            console.log("列表",fileList)
            this.imgList.push({id:file.data.id,url:this.httpUrl+'/disk/'+file.data.filePath})
            // this.fileIds.push({id:file.data.id,filePath:file.data.filePath})
        },
         successFun5(file,fileList){
            this.formExp.path=file.data.filePath;
            console.log(this.formExp)
        },
        //移除--附
        handleRemove1(file, fileList) {
            console.log("删除",file)
            let that=this;
            for(var i=0;i<that.imgList.length;i++){
                if(that.imgList[i].id==file.id){
                    that.imgList.splice(i,1);
                    break;
                }
            }
        },
        save(){
            let tempArr=[];
            for(let i=0; i<this.imgList.length;i++){
                tempArr.push(this.imgList[i].id)
            }
            this.form.fileIds=tempArr.join(',');
            if(this.isAdd==1){
                insert(this.form).then(res=>{
                    if(res.code==200){
                        this.$message.success("新增成功！");
                        this.cancel();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
            else{
                update(this.form).then(res=>{
                    if(res.code==200){
                        this.$message.success("修改成功！");
                        this.cancel();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
            }
        },
        del(val){
            del({id:val}).then(res=>{
                if(res.code==200){
                        this.$message.success("删除成功！");
                        this.listByPageFun();
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
        cancel(){
            this.isAdd=0;
            this.dialogVisible=false;
            this.dialogsort=false;
            this.form={
                filePath:""
            };
            this.imgList=[];
            this.listByPageFun();
            this.$refs.file.clearFiles();
        },
        cancel2(){
            // 说明
            this.dialogList=false;
            this.dialogExp=false;
            this.formExp={};
        }
    },
    mounted() {
        this.$nextTick(()=>{
            this.listByPageFun();
        })
    },
    created() {
        this.listByPageFun();
    },
    computed: {
    }
};
</script>

<style lang="less" scoped>
.table-blk{
    margin-top: -20px;
    .add-btn{
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #0091ff;
        -webkit-box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
        box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
        border-radius: 4px;
        padding: 0;
        cursor: pointer;
        color: #ffffff;
        }
    }
.sort-blk{
    padding:10px 20px;
    display: flex;
    justify-content: space-between;
    div{
        width: 25%;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .img{
            width: 60%;
            height: 100px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                max-height: 100%;
            }
        }
        /deep/.el-input{
            width: 60%;
            margin-top: 20px;
            .el-input__inner{
                text-align: center;
            }
        }
    }
}
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.avatar-uploader{
    .avatar-uploader-icon{
        padding:11px 25px;
        border-radius: 4px;
        border:1px #ccc solid;
    }
}
</style>
